import axios from "axios";

const API_URL = import.meta.env.VITE_API_URL;
const API_DESPACHO = import.meta.env.VITE_API_DESPACHO;
const API_DESPACHO_WEB = import.meta.env.VITE_API_DESPACHO_WEB;
const API_KEEPER = import.meta.env.VITE_API_KEEPER;

const DispatchInfoService = {
    getDispatch: async (id) => axios.get(API_URL + `/reports/dispatch_info/${id}/data`).then(({ data }) => data).catch((err) => { throw err }),

    getAttach: (id) => API_DESPACHO + `/attachment/print/${id}`,

    getImage: (id) => API_URL + `/public/assets/img/file-types/${id}.png`,
}

export default DispatchInfoService;